import { ChevronDown } from 'lucide-react'
import type { CompetitionOption } from '../lib/competitionOptions'
import styles from './CompetitionSelect.module.css'

type CompetitionSelectProps = {
  competitions: CompetitionOption[]
  value:        string
  onChange:     (id: string) => void
}

export function CompetitionSelect({ competitions, value, onChange }: CompetitionSelectProps) {
  if (competitions.length <= 1) {
    return <span className={styles.single}>{competitions[0]?.name ?? ''}</span>
  }

  return (
    <div className={styles.wrapper}>
      <select
        className={styles.select}
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-label="Selecionar competição"
      >
        {competitions.map(comp => (
          <option key={comp.id} value={comp.id}>{comp.name}</option>
        ))}
      </select>
      <ChevronDown size={13} className={styles.chevron} />
    </div>
  )
}
